import React from 'react';

interface Props
  extends Omit<React.SVGAttributes<SVGElement>, 'width' | 'height'> {
  size?: number | string;
}

const Add: React.FunctionComponent<Props> = (props) => {
  const { size = 16, ...restProps } = props;
  return (
    <svg
      {...restProps}
      width={size}
      height={size}
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <g clipPath='url(#clip0_10035_96664)'>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M9.80125 8.00004L5.45337 7.26851L3.66408 3.9312C3.5393 3.69814 3.58886 3.41652 3.78742 3.23338C3.986 3.05025 4.28837 3.00639 4.53684 3.12545L13.6092 7.46378C13.8247 7.56698 13.9607 7.77407 13.9607 8.00005C13.9607 8.22603 13.8247 8.43311 13.6091 8.53632L4.53684 12.8746C4.28837 12.9937 3.986 12.9498 3.78742 12.7667C3.58886 12.5836 3.5393 12.3019 3.66408 12.0689L5.46204 8.7154L9.80125 8.00004Z'
          fill='white'
        />
      </g>
      <defs>
        <clipPath id='clip0_10035_96664'>
          <rect
            width='15.821'
            height='15.821'
            fill='white'
            transform='translate(0.0895996 0.0895996)'
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Add;
